import React from 'react';
import './App.css';
import { AlertTriangle, Mail, Phone, Clock, Shield } from "lucide-react"
import MDLogo from "./images/MDLogo-50.png"
import SiteownerCard from "./components/SiteownerCard"
import CommonReasonsCard from "./components/CommonReasonsCard";
import AssistanceCard from "./components/AssistanceCard";

function App() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100">
      {/* Header */}
      <header className="border-b border-slate-200">
        <div className="container mx-auto px-4 py-4">
          <div className="flex items-center justify-between">
            <a href={'https://www.mataodesigns.com'} target={'_blank'} className="flex items-center space-x-2" rel="noreferrer">
              <img src={MDLogo} alt={'Matao Designs'}/>
              <span className="text-xl font-semibold text-slate-800">Matao Designs Websites</span>
            </a>
            <div className="text-sm text-slate-600">Email &amp; Phone Support Available</div>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="container mx-auto px-4 py-16">
        <div className="max-w-4xl mx-auto">
          {/* Alert Section */}
          <div className="text-center mb-12">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-amber-100 rounded-full mb-6">
              <AlertTriangle className="h-8 w-8 text-amber-600"/>
            </div>
            <h1 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">Website Temporarily Unavailable</h1>
            <p className="text-xl text-slate-600 max-w-2xl mx-auto leading-relaxed">
              This website has been temporarily removed from our servers. If you are the site owner, please contact your
              web hosting provider to reactivate your account.
            </p>
          </div>

          {/* Information Cards */}
          <div className="card-grid">
            <SiteownerCard />
            <CommonReasonsCard />
          </div>

          {/* Assistance Section */}
          <AssistanceCard />



          {/* Additional Information */}
          <div className="mt-12 text-center">
            <p className="text-slate-500 text-sm max-w-2xl mx-auto">
              If you are a visitor to this site, please check back later. The site owner has been notified and is
              working to resolve this issue. We apologize for any inconvenience.
            </p>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="border-t bg-white/80 backdrop-blur-sm mt-16">
        <div className="container mx-auto px-4 py-8">
          <div className="flex flex-col md:flex-row items-center justify-between">
            <div className="flex items-center space-x-2 mb-4 md:mb-0">
              <Shield className="h-5 w-5 text-slate-600"/>
              <span className="text-slate-600 font-16">© {new Date().getFullYear()} Matao Designs. All rights reserved.</span>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;
